import {Editor} from 'tinymce';

import {
  filterAutocompleteItems,
  flattenMergeTagsListForAutocomplete,
} from './utils';
import {getMergeTagsList, getMergeTagsPrefix} from '../api/Options';

const register = (editor: Editor): void => {
  const onAction = (value: string) => {
    editor.execCommand('pmAddMergeTag', false, value);
  }
  const prefix = getMergeTagsPrefix(editor);

  editor.ui.registry.addAutocompleter('merge_tags', {
    trigger: prefix,
    minChars: 0,
    columns: 1,
    fetch: (pattern: any, maxResults: any, meta: any) => {
      /*
       * `mergeTagsList` can change, that's why we fetch the latest version.
       */
      const mergeTagsList = getMergeTagsList(editor);

      return new Promise((resolve) => {
        resolve(
          filterAutocompleteItems(
            flattenMergeTagsListForAutocomplete(mergeTagsList),
            pattern
          )
        );

      });
    },
    onAction: (autocompleteApi: any, rng: any, value: string, meta: any) => {
      editor.selection.setRng(rng);
      onAction(value);
      autocompleteApi.hide();
    }
  })
};

export {
  register
};
